import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { changePackageStatus, searchTenantPackages } from '../../../api/sportaloka-client';
import FilterModal from '../components/FilterModal';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function PackagesTable({ onFilterLengthChanged }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    status: ['PUBLISHED', 'DRAFT'],
    keyword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getStatusObject = (status) => {
    switch (status) {
      case 'PUBLISHED':
        return {
          color: 'blue-2',
          textColor: 'blue-1',
          label: 'AKTIF',
          icon: 'fa fa-check'
        };
      default:
        return {
          color: 'red-3',
          textColor: 'red-1',
          label: 'NON-AKTIF',
          icon: 'fa fa-close'
        };
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: paginationOptions.status.join(','),
        keyword: paginationOptions.keyword
      }).toString();
      const response = await searchTenantPackages(query);
      const responseData = response.data.data.data.map((item) => ({
        ...item,
        status: getStatusObject(item.status)
      }));
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (statuses, keyword) => {
    const filterLength = keyword ? 1 : 0;
    setPaginationOptions({ ...paginationOptions, status: statuses, keyword });
    onFilterLengthChanged(statuses.length + filterLength);
  };

  const handleSort = (field) => {
    const isAsc = paginationOptions.sort_field === field && paginationOptions.sort_value === 'asc';
    setPaginationOptions({
      ...paginationOptions,
      sort_field: field,
      sort_value: isAsc ? 'desc' : 'asc'
    });
  };

  const handleChangeStatus = async (val, id) => {
    try {
      setLoading(true);
      setData([]);
      await changePackageStatus(id, val);
      await getData();
      Swal.fire({
        title: 'Berhasil!',
        text: `Status paket berhasil diperbarui`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <FilterModal onFilter={handleFilter} />
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ width: '15%' }}>Nama (ID)</th>
            <th style={{ width: '15%' }}>Nama (EN)</th>
            <th>Harga Lokal</th>
            <th>Harga Asing</th>
            <th>Status</th>
            <th className="cursor-pointer text-left" onClick={() => handleSort('updated_at')}>
              Update Terakhir
              {paginationOptions.sort_field === 'updated_at' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.name_id}</td>
              <td>{row.name_en}</td>
              <td>{row.local_price.toLocaleString('id-ID')}</td>
              <td>{row.foreign_price.toLocaleString('id-ID')}</td>
              <td>
                <div
                  className={`rounded-100 py-4 d-inline px-10 text-center col-12 text-14 fw-600 bg-${row.status.color} text-${row.status.textColor}`}>
                  <i className={row.status.icon}></i>
                </div>
              </td>
              <td className="text-left">{format(new Date(row.updated_at), 'dd/MM/yyyy hh:mm')}</td>
              <td className="text-center pe-0">
                <Link
                  to={`/packages/detail/${row.slug_id}`}
                  className="fw-500 text-blue-1 btn btn-primary text-white btn-sm border-blue-1 mr-10">
                  Ubah
                </Link>
                <button
                  onClick={() =>
                    handleChangeStatus(row.status.label === 'AKTIF' ? 'DRAFT' : 'PUBLISHED', row.id)
                  }
                  className="fw-500 text-blue-1 btn btn-info text-white btn-sm">
                  {row.status.label === 'AKTIF' ? 'Non-aktifkan' : 'Aktifkan'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default PackagesTable;
